import React, { useState, useEffect, useContext } from "react";
import { Button, Tabs, Row, Col, Collapse } from "antd";
import { useNavigate } from "react-router-dom";
import Questions from '../questions/questions.component';
import { listFaqs } from '../../services/faq.service';
import FaqCode from "../../enums/faqCode.enum";
import "./treatments.scss";
import { RightCircleFilled } from "@ant-design/icons";
import FlowType from "../../enums/flowType.enum";
import CitationFootnote from "../citationFootnote/citationFootnote.component";
import TreatmentTimeline from "./treatmentTimeline.component";
import PosthogHelper from "../../helpers/posthog.helper";
import { UserContext } from "../../contexts/user.context";

const { Panel } = Collapse;

const citations = [
  {
    index: 1,
    authors: "Jahn, L., Hartline, L., Liu, Z., & Barrett, E.",
    title: "Metformin improves skeletal muscle microvascular insulin resistance in metabolic syndrome",
    journal: "American Journal of Physiology - Endocrinology and Metabolism",
    link: "https://doi.org/10.1152/ajpendo.00287.2021"
  },
  {
    index: 2,
    authors: "Salpeter, S., Buckley, N., Kahn, J., & Salpeter, E.",
    title: "Meta-analysis: metformin treatment in persons at risk for diabetes mellitus",
    journal: "The American journal of medicine",
    link: "https://doi.org/10.1016/j.amjmed.2007.09.016"
  },
  {
    index: 3,
    authors: "Jahn, L., Hartline, L., Liu, Z., & Barrett, E.",
    title: "Metformin improves skeletal muscle microvascular insulin resistance in metabolic syndrome",
    journal: "American Journal of Physiology - Endocrinology and Metabolism",
    link: "https://doi.org/10.1152/ajpendo.00287.2021"
  },
  {
    index: 4,
    authors: "  Chukir, T., Mandel, L., Tchang, B., Mulla, N., Igel, L., Kumar, R., Waitman, J., Aronne, L., & Shukla, A.",
    title: "Metformin-induced weight loss in patients with or without type 2 diabetes/prediabetes: A retrospective cohort study",
    journal: "Obesity research & clinical practice",
    link: "https://doi.org/10.1016/j.orcp.2020.12.005"
  },
  {
    index: 5,
    authors: "Solymár, M., Ivic, I., Pótó, L., Hegyi, P., Garami, A., Hartmann, P., Pétervári, E., Czopf, L., Hussain, A., Gyöngyi, Z., Sarlós, P., Simon, M., Mátrai, P., Bérczi, B., & Balaskó, M.",
    title: "Metformin induces significant reduction of body weight, total cholesterol and LDL levels in the elderly – A meta-analysis",
    journal: "PLoS ONE",
    link: "https://doi.org/10.1371/journal.pone.0207947"
  },
  {
    index: 6,
    authors: "Haber, R., Zarzour, F., Ghezzawi, M., Saadeh, N., Bacha, D., Jebbawi, L., Chakhtoura, M., & Mantzoros, C.",
    title: "The impact of metformin on weight and metabolic parameters in patients with obesity: A systematic review and meta-analysis of randomized controlled trials",
    journal: "Diabetes",
    link: "https://doi.org/10.1111/dom.15501"
  },
  
  {
    index: 7,
    authors: "Bray, G., Edelstein, S., Crandall, J., Aroda, V., Franks, P., Fujimoto, W., Horton, E., Jeffries, S., Montez, M., Mudaliar, S., Pi‐Sunyer, F., White, N., & Knowler, W.",
    title: "Long-Term Safety, Tolerability, and Weight Loss Associated With Metformin in the Diabetes Prevention Program Outcomes Study",
    journal: "Diabetes Care",
    link: "https://doi.org/10.2337/dc11-1299"
  },
  
  {
    index: 8,
    authors: "Snaith, J., Olsen, N., Kowalski, G., Bruce, C., Evans, J., Januszewski, A., Jenkins, A., Breit, S., Holmes-Walker, J., & Greenfield, J.",
    title: "865-P: Metformin Reduces Insulin Dose and Visceral Fat Accumulation, and Increases GDF15 without Reducing Insulin Resistance in Adults with Type 1 Diabetes—A 26-Week, Randomized, Double-Blind Placebo-Controlled Trial (INTIMET)",
    journal: "Diabetes",
    link: "https://doi.org/10.2337/db24-865-p"
  },

  {
    index: 9,
    authors: "Zheng, J., Xu, M., Yang, Q., Hu, C., Walker, V., Lu, J., Wang, J., Liu, R., Xu, Y., Wang, T., Zhao, Z., Yuan, J., Burgess, S., Yeung, S., Luo, S., Anderson, E., Holmes, M., Smith, G., Ning, G., Wang, W., Gaunt, T., & Bi, Y.",
    title: "Efficacy of metformin targets on cardiometabolic health in the general population and non-diabetic individuals: a Mendelian randomization study",
    journal: "eBioMedicine",
    link: "https://doi.org/10.1016/j.ebiom.2023.104803"
  },

  {
    index: 10,
    authors: "Kupreeva, M., Diane, A., Lehner, R., Watts, R., Ghosh, M., Proctor, S., & Vine, D.",
    title: "Effect of metformin and flutamide on insulin, lipogenic and androgen-estrogen signaling, and cardiometabolic risk in a PCOS-prone metabolic syndrome rodent model",
    journal: "American journal of physiology. Endocrinology and metabolism",
    link: "https://doi.org/10.1152/ajpendo.00018.2018"
  },
  
  {
    index: 11,
    authors: "Osorio-Llanes, E., Villamizar-Villamizar, W., Guerra, M., Díaz-Ariza, L., Castiblanco-Arroyave, S., Medrano, L., Mengual, D., Belón, R., Castellar-López, J., Sepulveda, Y., Vásquez-Trincado, C., Chang, A., Bolívar, S., & Mendoza-Torres, E.",
    title: "Effects of Metformin on Ischemia/Reperfusion Injury: New Evidence and Mechanisms",
    journal: "Pharmaceuticals",
    link: "https://doi.org/10.3390/ph16081121"
  },
  
  {
    index: 12,
    authors: "Osorio-Llanes, E., Villamizar-Villamizar, W., Guerra, M., Díaz-Ariza, L., Castiblanco-Arroyave, S., Medrano, L., Mengual, D., Belón, R., Castellar-López, J., Sepulveda, Y., Vásquez-Trincado, C., Chang, A., Bolívar, S., & Mendoza-Torres, E.",
    title: "Effects of Metformin on Ischemia/Reperfusion Injury: New Evidence and Mechanisms",
    journal: "Pharmaceuticals",
    link: "https://doi.org/10.3390/ph16081121"
  },

  {
    index: 13,
    authors: "Kulkarni, A., Gubbi, S., & Barzilai, N.",
    title: "Benefits of Metformin in Attenuating the Hallmarks of Aging",
    journal: "Cell metabolism",
    link: "https://doi.org/10.1016/j.cmet.2020.04.001"
  },

  {
    index: 14,
    authors: "Dong, Y., Qi, Y., Jiang, H., Mi, T., Zhang, Y., Peng, C., Li, W., Zhang, Y., Zhou, Y., Zang, Y., & Li, J.",
    title: "The development and benefits of metformin in various diseases",
    journal: "Frontiers of Medicine",
    link: "https://doi.org/10.1007/s11684-023-0998-6"
  },

  {
    index: 15,
    authors: "Drzewoski, J., & Hanefeld, M.",
    title: "The Current and Potential Therapeutic Use of Metformin—The Good Old Drug",
    journal: "Pharmaceuticals",
    link: "https://doi.org/10.3390/ph14020122"
  },

  {
    index: 16,
    authors: "Dutta, S., Shah, R., Singhal, S., Dutta, S., Bansal, S., Sinha, S., & Haque, M.",
    title: "Metformin: A Review of Potential Mechanism and Therapeutic Utility Beyond Diabetes",
    journal: "Drug Design, Development and Therapy",
    link: "https://doi.org/10.2147/DDDT.S409373"
  },

];

const mechanismData = [
  {
    key: "1",
    label: "⚙️ Shifts Energy Balance in Liver Cells",
    content: (
      <>
        <p>
          <strong className="pathway-lead-in">Metformin’s effects start deep inside the liver, where it alters how cells generate energy.
          </strong>
        </p>
        
        <p>
          Inside each liver cell are mitochondria, which are small structures that function like power plants. They convert nutrients such as glucose and fat into ATP (adenosine triphosphate), the molecule that stores energy for the cell to use.
        </p>
        
        <p>
          Metformin partially blocks a specific protein inside mitochondria called complex I. This reduces the amount of ATP the cell can make. The decrease in energy is modest and does not harm the cell, but it creates an internal signal that energy availability is limited.   
        </p>
        
        <p>
          This matters because making glucose in the liver, a process called gluconeogenesis, requires a large amount of energy. When ATP is in short supply, liver cells begin to scale back this process. As a result, the liver produces less glucose, especially during fasting, when gluconeogenesis is normally active.
        </p>

        <p>
          This change also helps reduce oxidative stress. When mitochondria are overactive, they can generate unstable molecules called reactive oxygen species that damage cells. Metformin slows this overload and brings the energy environment of the liver into a more stable range.
        </p>
      </>
          
    ),
  },

  {
    key: "2",
    label: "🔋  Turns On AMPK Signaling",
    content: (
      <>
        <p><strong className="pathway-lead-in">The drop in cellular energy turns on AMPK, a cellular switch that shifts your metabolism from storage mode to burn mode.</strong></p>
        <p>
          AMPK stands for AMP-activated protein kinase. It acts as an energy sensor inside the cell. When levels of ATP fall, another molecule called AMP (adenosine monophosphate) rises. AMP is a signal that energy is being used up faster than it is being replaced. When AMP builds up, AMPK becomes activated.        
        </p>

        <p>
          Once AMPK is turned on, it coordinates a broad metabolic response:
          <ul>
            <li>In the liver, it further reduces glucose production and fat synthesis</li>
            <li>In muscle, it increases fat burning and improves the uptake of glucose</li>
            <li>In fat tissue, it decreases storage and promotes the release of stored energy</li>
            <li>Across all tissues, it improves insulin sensitivity, making it easier for cells to respond to insulin without requiring more of it</li>
          </ul>
        </p>

        <p>
          In muscle cells, AMPK increases the number of proteins called GLUT4 transporters. These transporters move to the surface of the cell and allow glucose to enter more easily. This helps muscles absorb sugar from the bloodstream, even when insulin levels are low.
        </p>

        <p>
          This AMPK-driven response is similar to what happens during fasting or intense exercise. Metformin activates the same pathway, not by pushing hormones but by mimicking the signal of energy scarcity from within the cell itself.
        </p>
 
      </>
    ),
  },
  {
    key: "3",
    label: "🛑  Lowers Liver Glucose Output",
    content: (
      <>
        <p>
          <strong className="pathway-lead-in">As energy drops and AMPK is activated, the liver scales back one of its most important and often harmful tasks in insulin resistance: the release of excess glucose.</strong>
        </p>

        <p>
          The liver is constantly engaged in gluconeogenesis, a process that builds new glucose molecules out of materials like lactate, amino acids, and glycerol. This output is essential during fasting or physical stress when dietary glucose is not available. But in insulin resistance, the liver loses its ability to slow this process after meals. It continues releasing glucose into the bloodstream even when there is already plenty of fuel available.
        </p>

        <p>
          Metformin helps the liver correct this overproduction. By limiting the energy supply and activating energy-sensing pathways, the liver reduces its capacity to drive gluconeogenesis. Enzyme systems that govern the construction and export of glucose slow down. This includes PEPCK, which catalyzes an early step in the glucose-building pathway, and G6Pase, which is required for the final step of releasing glucose into the bloodstream.
        </p>

        <p>
         The liver also loses some of its ability to convert glycerol, a fat breakdown product, into glucose. This is another result of metformin’s effect on mitochondrial enzymes.       
        </p>

        <p>
          The net result is a meaningful reduction in the liver’s glucose output. Instead of requiring insulin to clean up after the fact, metformin lowers the amount of glucose that needs managing in the first place. This shifts the burden away from the pancreas and helps the entire system function with less strain.
        </p>
        
      </>
    ),
  },



];

const timelineItems = [
  {
    key: '1',
    label: 'Upload Lab Work',
    children: {
      label: 'STEP 1',
      title: 'Upload Lab Work',
      description: <>
        Confirm your eligibility for metformin treatment with recent lab results and short health questionnaire.
      </>,
      img: '/img/treatments/blood-draw.webp',
      body: <>
        <ul className="timeline-list">
          <li>
              <Row align="top">
                <Col>
                  <RightCircleFilled className="timeline-icon" />
                </Col>
                <Col>
                  Required: <a href="/test/glucose" target="_blank">Glucose</a> or <a href="/test/hba1c" target="_blank">HbA1c</a> within past 12 months
                </Col>
              </Row>
            </li>
            <li>
              <Row align="top">
                <Col>
                  <RightCircleFilled className="timeline-icon" />
                </Col>
                <Col>
                Quick and easy health questionnaire to ensure safe prescribing.
                </Col>
              </Row>
            </li>
            <li>
              <Row align="top">
                <Col>
                  <RightCircleFilled className="timeline-icon" />
                </Col>
                <Col>
                  Need labs? Get the <a href="/test/insulin-resistance-panel" target="_blank">Insulin Resistance Panel</a> for a robust picture.
                </Col>
              </Row>
            </li>
          </ul>
        </>
      }
  },
  {
    key: '2',
    label: `Start Treatment`,
    children: {
      label: 'STEP 2',
      title: 'Start Treatment',
      description: <>
        A board-certified physician will review your lab results and health info to ensure metformin is the right fit for you.
      </>,
      img: '/img/treatments/medication-delivery.webp',
      body: <>
  
          <ul className="timeline-list">
            <li>
              <Row align="top">
                <Col>
                  <RightCircleFilled className="timeline-icon" />
                </Col>
                <Col>
                  Reviewed and approved by a physician.
                </Col>
              </Row>
            </li>
            <li>
              <Row align="top">
                <Col>
                  <RightCircleFilled className="timeline-icon" />
                </Col>
                <Col>
                Medication shipped directly to your door.
                </Col>
              </Row>
            </li>
            <li>
              <Row align="top">
                <Col>
                  <RightCircleFilled className="timeline-icon" />
                </Col>
                <Col>
                  Concierge support available for any follow-up questions.
                </Col>
              </Row>
            </li>
          </ul>
        </>
      }
  }, 
  {
    key: '3',
    label: 'Track Progress',
    children: {
      label: 'STEP 3',
      title: 'Track Progress',
      description: <>
        See how your body is responding with a follow-up lab panel at 6–12 weeks.
      </>,
      img: '/img/treatments/homa-ir.webp',
      body: <>
          <ul className="timeline-list">
            <li>
              <Row align="top">
                <Col>
                  <RightCircleFilled className="timeline-icon" />
                </Col>
                <Col>
                  Look for a drop in insulin resistance markers like <a href="/test/homa-ir" target="_blank">HOMA-IR</a>, <a href="/test/insulin" target="_blank">Insulin</a>, and <a href="/test/glucose" target="_blank">Glucose</a>.
                </Col>
              </Row>
            </li>
            <li>
              <Row align="top">
                <Col>
                  <RightCircleFilled className="timeline-icon" />
                </Col>
                <Col>
                 Optional: monitor body composition changes with <a href="/flow/dexa-bodycomp" target="_blank">DEXA scan</a>.
                </Col>
              </Row>
            </li>
            <li>
              <Row align="top">
                <Col>
                  <RightCircleFilled className="timeline-icon" />
                </Col>
                <Col>          
                  Note any changes in energy, reduced cravings, or side effects.
                </Col>
              </Row>
            </li>
          </ul>
          <p>Not seeing expected results? You can adjust your dose or combine treatments with 1-on-1 physician guidance through our <a href="/heart">Heart Health Program</a>.</p>
        </>
      }
  }

]

const safetyInfo = [
    {
      key: "1",
      title: "Safe for Most at Standard Dose",
      content: (<>
        <p>
        Metformin is generally very well tolerated, especially at typical starting doses (e.g., 500–1000 mg daily). It does not typically require frequent doctor visits once the right dose is established. However, ongoing monitoring ensures the best outcomes and safety. We recommend:

          <ul>
            <li>Checking kidney function (eGFR) before starting, and every 6–12 months thereafter</li>
            <li>Tracking vitamin B12 annually in long-term users, especially if you have symptoms like fatigue or tingling</li>
            <li>Avoiding excess alcohol intake, which can raise the risk of a rare but serious complication called lactic acidosis</li>
          </ul>
        </p>

        <p>If you have complex health needs, our <a href="/heart">Heart Health Program</a> offers additional physician oversight and safety tracking.</p>
      </>)
    },  
    {
      key: "2",
      title: "Possible Side Effects",
      content: (<>
        <p><strong>Possible and Usually Mild</strong></p>
      <p>Up to 30% of users may experience temporary gastrointestinal symptoms during the first few weeks, including:
        <ul>
          <li>Nausea</li>
          <li>Diarrhea or loose stools</li>
          <li>Mild abdominal discomfort</li>
          <li>Metallic taste in the mouth</li>
        </ul>
      </p>
      <p>These effects often improve with slow dose titration or switching to an extended-release (XR) formulation.</p>

      <p><strong>Less Common</strong></p>
      <p>Some patients may experience:</p>
      <ul>
        <li>Headache</li>
        <li>Weakness or fatigue</li>
        <li>Mild hypoglycemia (rare unless combined with other glucose-lowering drugs)</li>
        <li>Decreased vitamin B12 absorption with long-term use</li>
      </ul>

      </>)
    },
    {
      key: "4",
      title: "Rare but Serious: Lactic Acidosis",
      content: (<>
        <p>Metformin carries a black box warning for lactic acidosis, a rare but life-threatening condition that can occur if metformin accumulates in the body, usually due to impaired kidney or liver function. The estimated risk is around 1 in 30,000 patients, but mortality in diagnosed cases can be high.</p>
        <p>Symptoms to watch for:</p>
        <ul>
          <li>Rapid breathing or shortness of breath</li>
          <li>Muscle pain, profound fatigue</li>
          <li>Confusion, dizziness, or low blood pressure</li>
          <li>Nausea, vomiting, or abdominal discomfort</li>
        </ul>
        <p>Seek emergency care if these occur. Prompt discontinuation and dialysis can be life-saving.</p>
        <p>Higher risk groups include:</p>
        <ul>
          <li>People with kidney disease, liver disease, or heart failure</li>
          <li>Those undergoing surgery or imaging with iodinated contrast agents</li>
          <li>People who binge drink or are severely dehydrated</li>
        </ul>

      </>)
    },
    {
      key: "5",
      title: "Medication & Supplement Interactions",
      content: (<>

        <p>Metformin can interact with several medications that increase the risk of lactic acidosis or side effects:</p>
        <ul>
          <li>Contrast agents (used in imaging): temporarily stop metformin before and after imaging</li>
          <li>Alcohol: avoid excess consumption</li>
          <li>Drugs that affect kidney function: NSAIDs, ACE inhibitors, diuretics</li>
          <li>Carbonic anhydrase inhibitors: topiramate, zonisamide</li>
        <li>Certain antibiotics: trimethoprim</li>
        <li>B12-depleting drugs: proton pump inhibitors, metformin itself (long-term)</li>
      </ul>
      <p>Always share your full medication and supplement list so we can ensure safe prescribing.</p>
      </>)
    },
    {
      key: "6",
      title: "Pregnancy & Breastfeeding",
      content: (<>
        <p>Metformin is often used safely during pregnancy in women with PCOS, gestational diabetes, or type 2 diabetes. It crosses the placenta but is not associated with increased birth defect risk. Some studies suggest infants exposed to metformin in utero may have higher fat mass at birth, though long-term effects are still being studied.</p>
        <p>During breastfeeding, metformin passes into breast milk in very low amounts. No harmful effects have been reported in infants, even in those exclusively breastfed.</p> 
        <p>However, caution is advised when nursing newborns or premature infants or those with kidney problems.</p>

      </>)
    },
    {
      key: "8",
      title: "When to Stop and Seek Medical Advice",
      content: (<>
        <p>Discontinue metformin and contact your doctor or emergency services if you experience:</p>
        <ul>
          <li>Severe or worsening nausea, vomiting, or abdominal pain</li>
          <li>Difficulty breathing or deep, rapid breathing</li>
          <li>Muscle pain or profound weakness</li>
          <li>Confusion or drowsiness</li>
          <li>Yellowing of the skin or eyes (jaundice)</li>
        </ul>
        <p>These may be signs of lactic acidosis, liver injury, or other rare complications.</p>

      </>)
    },
    {
      key: "9",
      title: "About the Heart Health Program",
      content: (<>
        <p>Our <a href="/heart">Heart Health Program</a> is our comprehensive, physician-led care model, which is designed for people who want more support, more data, and more personalized insight.</p>
      
        <p>This program is ideal if you:
        <ul>
          <li>Combine metformin with other glucose-lowering medications</li>
          <li>Have prediabetes, fatty liver, or metabolic syndrome</li>
          <li>Want expert guidance on lifestyle, labs, and medications like metformin</li>
          <li>Need help interpreting complex lab panels</li>
          <li>Prefer consistent follow-up and optimization</li>

        </ul>
        </p>
        <p>What’s Included:
        <ul>
          <li>1-on-1 physician consultations for treatment planning, lab interpretation, and progress tracking</li>
          <li>Personalized plan to improve insulin resistance, blood sugar, and weight</li>
          <li>Ongoing monitoring to help optimize your regimen and manage side effects</li>
        </ul>
        </p>
        <p>Whether you’re just getting started or managing multiple health priorities, the Heart Health Program gives you the medical partnership you need to move forward with confidence.
        </p>
        <p><Button type="primary" size="large" onClick={() => window.location.href = '/heart'}>Learn More</Button></p>
        </>)
    }
]

const faqCodes = [
  FaqCode.METFORMIN_HOW_TO_KNOW,
  FaqCode.METFORMIN_WHY_TAKE,
  FaqCode.METFORMIN_COMBINED_WITH_OTHER_TREATMENTS,
  FaqCode.METFORMIN_REVERSE_INSULIN_RESISTANCE,
  FaqCode.METFORMIN_EVERY_OTHER_DAY,
  FaqCode.METFORMIN_LABS,
  FaqCode.METFORMIN_INCREASE_DOSAGE,
  FaqCode.METFORMIN_PHYSICIAN,
  FaqCode.METFORMIN_INSURANCE,
]     


export const Metformin = () => {
  const [faqs, setFaqs] = useState([]);
  const [tabPosition, setTabPosition] = useState("left");
  const navigate = useNavigate();
  const { currentUser } = useContext(UserContext)

  useEffect(() => {
    document.title = "Metformin (500 mg) - Reverse Insulin Resistance And Support Weight Loss"
  }, [])

  useEffect(() => {
    const fetchFaqs = async () => {
      const filter = {
        code: { 
          $in: faqCodes
        }
      }
      const response = await listFaqs({filter})
      const faqsSorted = faqCodes.map(code => response.find(faq => faq.code === code));
      setFaqs(faqsSorted)
    }

    fetchFaqs()
  }, [])

  useEffect(() => {
    PosthogHelper.track(currentUser, `[treatment] metformin view landing`, true)
  }, [currentUser])

  useEffect(() => {
    function handleResize() {
      setTabPosition(window.innerWidth < 768 ? "top" : "left");
    }
    handleResize(); // set on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    <div className="treatment-detail">
      {/* Hero Section */}
      <section className="treatment-hero">
        {/* Only for desktop */}
        <div className="treatment-hero__image treatment-hero__image--desktop">
          <img src="/img/treatments/metformin-on-table.webp" alt="Metformin Bottle" />
        </div>
        <div className="treatment-hero__info">
          <h1>Metformin (500 mg)<span className="treatment-hero__caption">: Reverse Insulin Resistance And Support Weight Loss</span></h1>
          <div className="treatment-hero__badges">
              <span className="badge">Clinically Backed</span>
              <span className="badge">HSA/FSA Eligible</span>
              <span className="badge">Free Shipping</span>
          </div>

          {/* Only for mobile */}
          <div className="treatment-hero__image treatment-hero__image--mobile">
            <img src="/img/treatments/metformin-bottle.webp" alt="Metformin Bottle" />
          </div>

          <p className="treatment-hero__subtitle">
          A proven, prevention-first tool to improve insulin sensitivity, lower blood sugar, and support healthy weight without causing crashes.
          {/* Metformin is one of the safest and most studied medications for protecting long-term health. It helps improve how your body uses insulin, keeps blood sugar in check, and supports sustainable weight loss. */}
          </p>
          <div className="treatment-hero__price">
            <span>Starting at $15/month</span>
          </div>

          <div className="treatment-hero__features">
    
            <div className="treatment-hero__feature">
              <h4>Proven Results, Minimal Side Effects</h4>
              <p>Metformin has a long safety track record and is well tolerated by most people. It doesn’t cause hunger, blood sugar crashes, or dependency like many other medications.
              </p>
            </div>
            <div className="treatment-hero__feature">
              <h4>Same Day Prescription Approval</h4>
              <p>Your prescription is evaluated and approved by a board-certified physician same day. This ensures this medication is safe for you.</p>
            </div>
            <div className="treatment-hero__feature">
              <h4>Trusted Pharmacy Partners</h4>
              <p>Your medication is filled through licensed U.S. pharmacies that follow strict protocols for quality, consistency, and safety, so every tablet meets the highest standard.</p>
            </div>
          </div>
          <div className="treatment-hero__cta">
            

            <div className="cta-container">
           
            <Button className="cta" type="primary" size="large" onClick={() => navigate(`/flow/${FlowType.METFORMIN}`)}>Get Started Now</Button>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="treatment-benefits">
        <div className="max-width-container">
        <h2>The Benefits of Metformin
          <div className="caption">A low-risk treatment that supports long-term metabolic health, weight control and disease prevention.</div>
        </h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <h3>Improves Insulin Sensitivity</h3>
            <p>
            Metformin helps your body respond more effectively to insulin by increasing glucose uptake in muscles and reducing glucose production in the liver. Studies show a 14-23% improvement in insulin resistance markers like HOMA-IR, even in people without diabetes              
            <CitationFootnote number={1} citation={citations[0]} />
              <CitationFootnote number={2} citation={citations[1]} />
              <CitationFootnote number={3} citation={citations[2]} />.
            </p>
          </div>
          <div className="benefit-card">
            <h3>Lowers Cardiometabolic Risk</h3>
            <p>
            Metformin improves insulin sensitivity and lowers triglycerides, blood pressure, and ApoB-containing particles, key drivers of cardiometabolic disease. These effects are linked to a 40% lower risk of type 2 diabetes and a 38% lower risk of coronary artery disease
              <CitationFootnote number={9} citation={citations[8]} />
              <CitationFootnote number={10} citation={citations[9]} />
              <CitationFootnote number={11} citation={citations[10]} />
              <CitationFootnote number={12} citation={citations[11]} />.
            </p>
          </div>

          <div className="benefit-card">
            <h3>Supports Healthy Weight Management</h3>
            <p>Metformin leads to modest but meaningful weight loss, typically around 5-6% of baseline body weight within 6 to 12 months. This effect is sustained in long-term studies, and especially beneficial for people who are overweight
              <CitationFootnote number={4} citation={citations[3]} />
              <CitationFootnote number={5} citation={citations[4]} />
              <CitationFootnote number={6} citation={citations[5]} />
              <CitationFootnote number={7} citation={citations[6]} />
              <CitationFootnote number={8} citation={citations[7]} />.
            </p>
          </div>

          <div className="benefit-card">
            <h3>Supports Healthspan and Aging Pathyways</h3>
            <p>Metformin activates cellular pathways tied to stress resistance and repair, and is associated with lower rates of cancer, cognitive decline, and premature death. While not a magic longevity pill, it shows promise for supporting a longer, healthier life
                <CitationFootnote number={13} citation={citations[12]} />
                <CitationFootnote number={14} citation={citations[13]} />
                <CitationFootnote number={15} citation={citations[14]} />
                <CitationFootnote number={16} citation={citations[15]} />.
              </p>
          </div>
 
        </div>
        </div>
      </section>

      {/* Treatment Steps */}
      <section className="treatment-steps">
        <div className="max-width-container">
          <h2>How to Start Metformin
            <div className="caption">A simple, safe, and data-driven way to begin treatment.</div>
          </h2>
          <TreatmentTimeline timelineItems={timelineItems} />
        </div>
      </section>

      {/* Mechanism Section */}
      <section className="treatment-pathways">
        <div className="max-width-container">
        <h2>How Metformin Works
          <div className="caption">The pharmacology behind its powerful, targeted effects.</div>
        </h2>
        <div className="pathways-tabs">
        <Tabs
          defaultActiveKey="1"
          tabPosition={tabPosition}
          items={mechanismData.map(tab => ({
            key: tab.key,
            label: tab.label,
            children: tab.content,
          }))}

        />
        </div>
      </div>

      </section>

      {/* Safety Information */}
      <section className="treatment-safety">
      <div className="max-width-container">
        <h2>Safety Information
        </h2>

        <div className="safety-info-intro">
          <p>Metformin is a widely used, first-line oral medication for managing insulin resistance and type 2 diabetes. It works by lowering glucose production in the liver and improving insulin sensitivity in muscle tissue. Importantly, unlike other similar medications, metformin does not stimulate insulin secretion, which means it generally does not cause low blood sugar (hypoglycemia) when used alone.
          </p>
        
          <p>Before starting metformin, we recommend recent lab tests, especially to assess kidney function (e.g., creatinine or cystatin C) since metformin is excreted renally and its safety depends heavily on proper kidney clearance.</p>
        
          <p>If you're looking for structured medical oversight, we offer the <a href="/heart">Heart Health Program</a>, which is a physician-led option that includes some lab testing, 1-on-1 physician support, and a personalized approach to managing your cardiometabolic health.
          </p>
        </div>

        <Collapse
          accordion
          bordered={false}
          className="safety-collapse"
        >
          {safetyInfo.map(item => (
            <Panel header={item.title} key={item.key}>
              {item.content}
            </Panel>
          ))}
     
        </Collapse>
      </div>
      </section>


      {/* FAQ */}
      {faqs?.length > 0 && 
      <section className="treatment-faq">
        <div className="max-width-container">
          <h2>Frequently Asked Questions</h2>
          <Questions items={faqs} />
        </div>
      </section>}


      {/* Related Articles */}
      {/* https://instalab.com/research/statin */}
      {/* https://instalab.com/research/evaluate-medication */}
      {/* https://instalab.com/research/sterol-test */}

    </div>
  );
}

export default Metformin;